const OSS = require('ali-oss');
const axios = require('axios');
const encryptedAccessKeyId = 'y7bv+qK66l/o6j6BRe02wrhDi/COCv8ycac4XAkcs1M=';
const encryptedAccessKeySecret = 'VioIG83gV6Iv411IwO1jh1kUNIOnzKu63OEqJ0MJO+I=';
import { generateOssConfig } from '@/assets/js/ossConfig';
const ossConfig = generateOssConfig("wisdom");
async function getOssConfigFromBackend() {
    try {
        const response = await axios.post('/knowledge-api/secret/manager/decrypt', {
            accessKeyId: encryptedAccessKeyId,
            accessKeySecret: encryptedAccessKeySecret
        });

        if (response.data.code === '0') {
            return {
                region: ossConfig.region,
                accessKeyId: response.data.data.accessKeyId,
                accessKeySecret: response.data.data.accessKeySecret,
                bucket: ossConfig.bucket
            };
        } else {
            console.error('获取 OSS 配置失败，错误码:', response.data.code);
            return null;
        }
    } catch (error) {
        console.error('获取 OSS 配置时出错:', error);
        return null;
    }
}

let IDX = 256, HEX = [], SIZE = 256, BUFFER;
while (IDX--) HEX[IDX] = (IDX + 256).toString(16).substring(1);
function uid(len) {
    let i = 0, tmp = (len || 11);
    if (!BUFFER || ((IDX + tmp) > SIZE * 2)) {
        for (BUFFER = '', IDX = 0; i < SIZE; i++) {
            BUFFER += HEX[Math.random() * 256 | 0];
        }
    }

    return BUFFER.substring(IDX, IDX++ + tmp);
}

function dataFormat(fmt, date = new Date()) {
    const o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (const k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function pathGenerate(filename) {
    let mainId = sessionStorage.getItem('_mainId');
    return mainId +'/' + dataFormat("yyyy/MM/dd/hh/mm/") + uid(32) + "/" + filename;
}


async function upload(config, data) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    let ossClient = new OSS(ossConfig);
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(data.name);
    let result = ossClient.put(objectKey, data);
    console.debug(result);
    return result;
}
async function uploadImageByBase64(config,blob) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    let ossClient = new OSS(ossConfig);

    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(new Date().getTime());
    let result = await ossClient.put(objectKey, blob);
    console.debug(result);
    return result;
}
async function multipartUpload(config, data, callback,extCallback) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    let ossClient = new OSS(ossConfig);
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(data.name);

    let res =  ossClient.multipartUpload(objectKey, data, {
        progress: function (p, checkpoint,res) {
            console.debug('progress callback', p, checkpoint);
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            if (callback && callback instanceof Function) {
                callback(p, checkpoint,res, data,extCallback);
            }
        }
    })
    return res;
}
async function multipartUploadChangeFilName(config, data, callback,extCallback) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    let ossClient = new OSS(ossConfig);
    const parts = data.name.split('.');
    const lastPart = parts[parts.length - 1];
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(uid(16) + '.' + lastPart);

    let res =  ossClient.multipartUpload(objectKey, data, {
        progress: function (p, checkpoint,res) {
            console.debug('progress callback', p, checkpoint);
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            if (callback && callback instanceof Function) {
                callback(p, checkpoint,res, data,extCallback);
            }
        }
    })
    return res;
}
async function publicMultipartUpload(config, data, callback,extCallback) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    let ossClient = new OSS(ossConfig);
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    let objectKey = pathGenerate(data.name);
    console.log('ossClient',ossClient)
    let res =  ossClient.multipartUpload(objectKey, data, {
        progress: function (p, checkpoint,res) {
            console.debug('progress callback', p, checkpoint);
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            if (callback && callback instanceof Function) {
                callback(p, checkpoint,res, data,extCallback);
            }
        },
        headers:{
            "x-oss-object-acl" : "public-read"
        }
    })

    return res;
}
async function ossFileUrl(config, path, cname) {
    const ossConfig = await getOssConfigFromBackend();
    if (!ossConfig) {
        return null;
    }
    if (cname == null) {
        return 'https://' + ossConfig.bucket + '.' + ossConfig.region + '.aliyuncs.com/' + path;
    } else {
        return cname + '/' + path;
    }
}

export {upload, multipartUpload,publicMultipartUpload, ossFileUrl,uploadImageByBase64,ossConfig, multipartUploadChangeFilName}
